import React, { useContext } from 'react';
import getUrlParam, { decodeUrlQueryValue } from 'components/Dashboard/utilities/getUrlParam';
import { Link, useLocation, useParams } from 'react-router-dom';
import { store } from 'components/Store';
import CreditsButton from 'components/Dashboard/components/CreditsButton';
const InfluenceHeader = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { remainingCredits } = state;

  const returnUrl = getUrlParam('returnUrl');
  const location = useLocation();

  const params = useParams();
  const { title } = params ?? {};

  const urlLink = () => {
    return `${!!returnUrl ? decodeUrlQueryValue(returnUrl) : `/brief-policymakers/${location?.state?.influencePage ? 'ai-assistant' : ''}`}`;
  };
  return (
    <>
      <div className='py-3 px-3 px-lg-0 settings-header'>
        <div className='mx-0 justify-content-between align-items-center row mx-auto main-content-wrapper w-100'>
          <div className='pl-md-5 pl-3 show-lg side-left-element'>
            <div className='d-flex position-relative'>
              <Link to={urlLink()} className='settings-logo d-inline-block' />
              <Link to={urlLink()} className='close-name-settings d-inline-block'>
                Close
              </Link>
            </div>
          </div>
          <div className={`main-content pr-xl-5 px-md-4 px-3 d-flex justify-content-end`}>
            {remainingCredits >= 0 && !!title && <CreditsButton type={'AI'} />}
          </div>
        </div>
      </div>
    </>
  );
};

export default InfluenceHeader;
